<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>供应商列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <!-- 搜索 -->
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="供应商名称">
          <el-input v-model="listQuery.supplyName" placeholder="请输入供应商名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="供应商地址">
          <el-input v-model="listQuery.supplyAddress" placeholder="请输入供应商地址" clearable></el-input>
        </el-form-item>
         <el-form-item label="供应商联系人">
          <el-input v-model="listQuery.supplyContactName" placeholder="请输入供应商联系人" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系人电话">
          <el-input v-model="listQuery.supplyContactPhone" placeholder="请输入联系人电话" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="listQuery.isEnabled" clearable placeholder="请选择状态">
            <el-option label="启用" :value="true"></el-option>
            <el-option label="停用" :value="false"></el-option>
          </el-select>
        </el-form-item>
             <el-form-item label="供应商等级">
          <el-select v-model="listQuery.supplyLevel" clearable placeholder="请选择供应商等级">
            <el-option label="A" value="A"></el-option>
            <el-option label="B" value="B"></el-option>
            <el-option label="C" value="C"></el-option>
            <el-option label="D" value="D"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期">
          <el-date-picker
            v-model="listQuery.timePart"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
          <el-button icon="el-icon-plus" type="primary" plan @click="addBrand">新增供应商</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table">
        <el-table-column prop="id" label="ID" width="50px" fixed="left"></el-table-column>

        <el-table-column prop="supplyName" label="供应商名称" width="160" fixed="left"></el-table-column>
        <el-table-column prop="supplyAddress" label="供应商地址"></el-table-column>
        <el-table-column prop="supplyContactName" label="供应商联系人姓名"></el-table-column>
        <el-table-column prop="supplyContactPhone" label="联系人电话"></el-table-column>
        <el-table-column prop="supplyLevel" label="供应商等级"></el-table-column>
             <el-table-column prop="accountPeriod" label="账期结算">
          <template slot-scope="scope">{{scope.row.accountPeriod | accountPeriodFilter}}</template>
        </el-table-column>
      <el-table-column prop="bankName" label="开户银行名称"></el-table-column>
      <el-table-column prop="bankCode" label="供应商银行账号"></el-table-column>
      <el-table-column prop="accountHolder" label="开户人"></el-table-column>
      <el-table-column prop="invoice" label="发票抬头"></el-table-column>
      <el-table-column prop="taxpayerNumber" label="纳税人编号"></el-table-column>
      <el-table-column prop="supplyRemark" label="供应商备注" width="180"></el-table-column>

        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.isEnabled">启用</span>
            <span v-if="scope.row.isEnabled==false">停用</span>
          </template>
        </el-table-column>

        <!-- <el-table-column prop="remark" label="备注"></el-table-column> -->
        <el-table-column prop="qualifyDocument" label="资质图片" width="200px">
          <template slot-scope="scope">
            <span v-if="scope.row.qualifyDocument==''">无</span>
            <el-image
              v-else
              slot="reference"
              :preview-src-list="scope.row.qualifyDocument.split(',')"
              v-for="item in scope.row.qualifyDocument.split(',')"
              :key="item.index"
              :src="item"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column prop="createTime" label="创建时间" :formatter="dateFormatA" width="140px"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" :formatter="dateFormatA" width="140px"></el-table-column>

        <el-table-column prop label="操作" fixed="right" width="180px" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="editBrand(scope.row)"
              :disabled="scope.row.status==2"
              size="mini"
            >编辑</el-button>
            <el-button
              type="text"
              @click="brandStatus(scope.row)"
              v-if="scope.row.isEnabled==true"
              class="red"
              size="mini"
            >停用</el-button>
            <el-button
              type="text"
              @click="brandStatus(scope.row)"
              v-if="scope.row.isEnabled==false"
              size="mini"
            >启用</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination
        :total="total"
        :page.sync="currentPage"
        :limit.sync="pageSize"
        @pagination="querySearch"
      />
    </el-card>

    <!-- 新增供应商 -->
    <el-dialog
      title="新增供应商"
      :visible.sync="addBrandVisible"
      width="900px"
      :close-on-click-modal="false"
      center
    >
      <el-form
        ref="addBrandForm"
        :rules="addRules"
        label-width="100px"
        :model="addBrandForm"
        size="medium"
      >

        <el-row>
           <el-col :span="12">
                <el-form-item label="供应商名称" prop="supplyName">
            <el-input v-model="addBrandForm.supplyName" clearable placeholder="请输入供应商名称"></el-input>
          </el-form-item>
           </el-col>
            <el-col :span="12">
                <el-form-item label="供应商地址" prop="supplyAddress">
            <el-input v-model="addBrandForm.supplyAddress" clearable placeholder="请输入供应商地址"></el-input>
          </el-form-item>
           </el-col>
        </el-row>
         <el-row>
           <el-col :span="12">
                <el-form-item label="联系人姓名" prop="supplyContactName">
            <el-input v-model="addBrandForm.supplyContactName" clearable placeholder="请输入联系人姓名"></el-input>
          </el-form-item>
           </el-col>
            <el-col :span="12">
                <el-form-item label="联系人电话" prop="supplyContactPhone">
            <el-input v-model="addBrandForm.supplyContactPhone" clearable placeholder="请输入联系人电话"></el-input>
          </el-form-item>
           </el-col>
        </el-row>
         <el-row>
           <el-col :span="12">
                <el-form-item label="供应商等级 " prop="supplyLevel">
            <el-select v-model="addBrandForm.supplyLevel" clearable placeholder="请选择状态">
            <el-option label="A" value="A"></el-option>
            <el-option label="B" value="B"></el-option>
            <el-option label="C" value="C"></el-option>
            <el-option label="D" value="D"></el-option>
          </el-select>
          </el-form-item>
           </el-col>
            <el-col :span="12">
                <el-form-item label="账期结算" prop="accountPeriod">
            <el-select v-model="addBrandForm.accountPeriod" clearable placeholder="请选择账期结算">
            <el-option
              v-for="(item,index) in accountPeriodList"
              :key="index"
              :label="item.text"
              :value="item.id"
            ></el-option>
          </el-select>
          </el-form-item>
           </el-col>
        </el-row>
       <el-row>
           <el-col :span="12">
                <el-form-item label="发票抬头" prop="invoice">
            <el-input v-model="addBrandForm.invoice" clearable placeholder="请输入发票抬头"></el-input>
          </el-form-item>
           </el-col>
            <el-col :span="12">
                <el-form-item label="纳税人编号" prop="taxpayerNumber">
            <el-input v-model="addBrandForm.taxpayerNumber" clearable placeholder="请输入纳税人编号"></el-input>
          </el-form-item>
           </el-col>
        </el-row>
         <el-row>
           <el-col :span="12">
                <el-form-item label="开户人" prop="accountHolder">
            <el-input v-model="addBrandForm.accountHolder" clearable placeholder="请输入开户人"></el-input>
          </el-form-item>
           </el-col>
            <el-col :span="12">
                <el-form-item label="开户银行" prop="bankName">
            <el-input v-model="addBrandForm.bankName" clearable placeholder="请输入开户银行"></el-input>
          </el-form-item>
           </el-col>
        </el-row>
         <el-row>
           <el-col :span="16">
                <el-form-item label="银行账号" prop="bankCode">
            <el-input v-model="addBrandForm.bankCode" clearable placeholder="请输入银行账号"></el-input>
          </el-form-item>
           </el-col>
            
        </el-row>

        

        <el-row>
          <el-form-item label="备注" prop="supplyRemark">
            <el-input
              type="textarea"
              style="width:600px"
              :rows="3"
              placeholder="请输入备注"
              v-model="addBrandForm.supplyRemark"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="图片上传:"></el-form-item>
        </el-row>
        <!-- <el-row> -->
        <el-upload
          :action="addFile"
          :on-change="handleOnChange"
          :file-list="addBrandImgList"
          :limit="5"
          :on-exceed="uploadOverrun"
          :auto-upload="false"
          :on-remove="handleRemove"
          accept=".jpg, .jpeg, .png, .gif"
          list-type="picture-card"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click=" addBrandVisible= false">取 消</el-button>
        <el-button type="primary" @click="confAddBrand('addBrandForm')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改供应商 -->

    <el-dialog
      title="修改供应商"
      :visible.sync="editBrandVisible"
      width="900px"
      :close-on-click-modal="false"
      center
    >
      <el-form
        ref="editBrandForm"
        :rules="editRules"
        label-width="100px"
        :model="editBrandForm"
        size="medium"
      >
       <el-row>
           <el-col :span="12">
                <el-form-item label="供应商名称" prop="supplyName">
            <el-input v-model="editBrandForm.supplyName" clearable placeholder="请输入供应商名称"></el-input>
          </el-form-item>
           </el-col>
            <el-col :span="12">
                <el-form-item label="供应商地址" prop="supplyAddress">
            <el-input v-model="editBrandForm.supplyAddress" clearable placeholder="请输入供应商地址"></el-input>
          </el-form-item>
           </el-col>
        </el-row>
         <el-row>
           <el-col :span="12">
                <el-form-item label="联系人姓名" prop="supplyContactName">
            <el-input v-model="editBrandForm.supplyContactName" clearable placeholder="请输入联系人姓名"></el-input>
          </el-form-item>
           </el-col>
            <el-col :span="12">
                <el-form-item label="联系人电话" prop="supplyContactPhone">
            <el-input v-model="editBrandForm.supplyContactPhone" clearable placeholder="请输入联系人电话"></el-input>
          </el-form-item>
           </el-col>
        </el-row>
         <el-row>
           <el-col :span="12">
                <el-form-item label="供应商等级 " prop="supplyLevel">
            <el-select v-model="editBrandForm.supplyLevel" clearable placeholder="请选择状态">
            <el-option label="A" value="A"></el-option>
            <el-option label="B" value="B"></el-option>
            <el-option label="C" value="C"></el-option>
            <el-option label="D" value="D"></el-option>
          </el-select>
          </el-form-item>
           </el-col>
            <el-col :span="12">
                <el-form-item label="账期结算" prop="accountPeriod">
            <el-select v-model="editBrandForm.accountPeriod" clearable placeholder="请选择账期结算">
            <el-option
              v-for="(item,index) in accountPeriodList"
              :key="index"
              :label="item.text"
              :value="item.id"
            ></el-option>
          </el-select>
          </el-form-item>
           </el-col>
        </el-row>
       <el-row>
           <el-col :span="12">
                <el-form-item label="发票抬头" prop="invoice">
            <el-input v-model="editBrandForm.invoice" clearable placeholder="请输入发票抬头"></el-input>
          </el-form-item>
           </el-col>
            <el-col :span="12">
                <el-form-item label="纳税人编号" prop="taxpayerNumber">
            <el-input v-model="editBrandForm.taxpayerNumber" clearable placeholder="请输入纳税人编号"></el-input>
          </el-form-item>
           </el-col>
        </el-row>
         <el-row>
           <el-col :span="12">
                <el-form-item label="开户人" prop="accountHolder">
            <el-input v-model="editBrandForm.accountHolder" clearable placeholder="请输入开户人"></el-input>
          </el-form-item>
           </el-col>
            <el-col :span="12">
                <el-form-item label="开户银行" prop="bankName">
            <el-input v-model="editBrandForm.bankName" clearable placeholder="请输入开户银行"></el-input>
          </el-form-item>
           </el-col>
        </el-row>
         <el-row>
           <el-col :span="16">
                <el-form-item label="银行账号" prop="bankCode">
            <el-input v-model="editBrandForm.bankCode" clearable placeholder="请输入银行账号"></el-input>
          </el-form-item>
           </el-col>
            
        </el-row>

        

        <el-row>
          <el-form-item label="备注" prop="supplyRemark">
            <el-input
              type="textarea"
              style="width:600px"
              :rows="3"
              placeholder="请输入备注"
              v-model="editBrandForm.supplyRemark"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="图片上传:"></el-form-item>
        </el-row>
        <!-- <el-row> -->
        <el-upload
          :action="addFile2"
          :on-change="handleOnChange2"
          :file-list="editBrandImgList"
          :limit="5"
          :on-exceed="uploadOverrun2"
          :auto-upload="false"
          :on-remove="handleRemove2"
          accept=".jpg, .jpeg, .png, .gif"
          list-type="picture-card"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click=" editBrandVisible= false">取 消</el-button>
        <el-button type="primary" @click="confEditBrand('editBrandForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import Pagination from "../common/Pagination";
import Service from "@/script/api/service";
import wmsApi from "@/script/api/wmsApi";
import globalData from "@/components/common/globaldata/global.data.vue";
import "./css/index.css";
let vm;
export default {
  components: { Pagination },
   filters: {
    accountPeriodFilter(value) {
      const rs = vm.accountPeriodList.filter(item => {
        return item.id === value;
      });

      if (rs != null && rs.length > 0) {
        return rs[0].text;
      }
    }
  },
  
  data() {
    return {
      listData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        supplyName: "",
        supplyAddress: "",
        supplyContactName: "",
        supplyContactPhone: "",
        supplyLevel: "",
        isEnabled: null,
        timePart: []
      },
      accountPeriodList:[
         {
          id: 1,
          text: "年结"
        },
        {
          id: 2,
          text: "季结"
        },
         {
          id: 3,
          text: "月结"
        },
         {
          id: 4,
          text: "周结"
        },
         {
          id: 5,
          text: "日结"
        },
         {
          id: 6,
          text: "按次结算"
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近半个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },

      addBrandVisible: false,
      addBrandForm: {
        supplyName: "",
        supplyAddress: "",
        supplyContactName: "",
        supplyContactPhone: "",
        supplyLevel: "",
        accountPeriod: "",
        invoice: "",
        taxpayerNumber: "",
        accountHolder: "",
        bankName: "",
        bankCode: "",
        supplyRemark: "",
      },
      addBrandImgList: [],
      editBrandImgList: [],
      addFile: Service.addFile + globalData.userInfo.userAccount,
      addFile2: Service.addFile + globalData.userInfo.userAccount,
      addRules: {
        supplyName: [
          { required: true, message: "请输入供应商名称", trigger: "change" }
        ],
        supplyAddress: [
          { required: true, message: "请输入供应商地址", trigger: "change" }
        ],
        supplyContactName: [
          { required: true, message: "请输入联系人姓名", trigger: "change" }
        ],
        supplyContactPhone: [
          { required: true, message: "请输入联系人电话", trigger: "change" }
        ],
        supplyLevel: [
          { required: true, message: "请选择供应商等级", trigger: "change" }
        ],
        accountPeriod: [
          { required: true, message: "请选择账期结算", trigger: "change" }
        ],
        invoice: [
          { required: true, message: "请输入发票抬头", trigger: "change" }
        ],
        taxpayerNumber: [
          { required: true, message: "请输入纳税人编号", trigger: "change" }
        ],
        accountHolder: [
          { required: true, message: "请输入开户人", trigger: "change" }
        ],
        bankName: [
          { required: true, message: "请输入开户银行", trigger: "change" }
        ],
        bankCode: [
          { required: true, message: "请输入银行账号", trigger: "change" }
        ],
      },
      brandInfo: {},
      editBrandVisible: false,
      editBrandForm: {
         supplyName: "",
        supplyAddress: "",
        supplyContactName: "",
        supplyContactPhone: "",
        supplyLevel: "",
        accountPeriod: "",
        invoice: "",
        taxpayerNumber: "",
        accountHolder: "",
        bankName: "",
        bankCode: "",
        supplyRemark: "",
      },
      editRules: {
        supplyName: [
          { required: true, message: "请输入供应商名称", trigger: "change" }
        ],
        supplyAddress: [
          { required: true, message: "请输入供应商地址", trigger: "change" }
        ],
        supplyContactName: [
          { required: true, message: "请输入联系人姓名", trigger: "change" }
        ],
        supplyContactPhone: [
          { required: true, message: "请输入联系人电话", trigger: "change" }
        ],
        supplyLevel: [
          { required: true, message: "请选择供应商等级", trigger: "change" }
        ],
        accountPeriod: [
          { required: true, message: "请选择账期结算", trigger: "change" }
        ],
        invoice: [
          { required: true, message: "请输入发票抬头", trigger: "change" }
        ],
        taxpayerNumber: [
          { required: true, message: "请输入纳税人编号", trigger: "change" }
        ],
        accountHolder: [
          { required: true, message: "请输入开户人", trigger: "change" }
        ],
        bankName: [
          { required: true, message: "请输入开户银行", trigger: "change" }
        ],
        bankCode: [
          { required: true, message: "请输入银行账号", trigger: "change" }
        ],
      }
    };
  },
  beforeCreate() {
    vm = this;
  },
  created() {
    this.querySearch();
  },
  methods: {
    //查询
    querySearch() {
      let temp = {
        page: this.currentPage,
        size: this.pageSize,
        supplyName: this.listQuery.supplyName,
        supplyAddress: this.listQuery.supplyAddress,
        supplyContactName: this.listQuery.supplyContactName,
        supplyContactPhone: this.listQuery.supplyContactPhone,
        supplyLevel: this.listQuery.supplyLevel,
        isEnabled: this.listQuery.isEnabled
      };
      if (
        this.listQuery.timePart != "" &&
        this.listQuery.timePart != undefined
      ) {
        temp.createTimeStart = this.listQuery.timePart[0]
          .getTime()
          .toString()
          .substr(0, 10);
        temp.createTimeEnd = this.listQuery.timePart[1]
          .getTime()
          .toString()
          .substr(0, 10);
      }
      wmsApi
        .$axiosSupplierList(temp)
        .then(res => {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    },
    brandStatus(row) {
      this.$confirm(`确定${row.isEnabled ? "停用" : "启用"}该供应商吗？`)
        .then(_ => {
          if (row.isEnabled) {
            wmsApi
              .$axiosDisableSupplier({
                supplierId: row.id
              })
              .then(res => {
                this.$message.success(
                  `${row.isEnabled ? "停用" : "启用"}成功！`
                );
                this.querySearch();
              })
              .catch(err => {
                console.log(err);
              });
          } else {
            wmsApi
              .$axiosAbleSupplier({
                supplierId: row.id
              })
              .then(res => {
                this.$message.success(
                  `${row.isEnabled ? "停用" : "启用"}成功！`
                );
                this.querySearch();
              })
              .catch(err => {
                console.log(err);
              });
          }
        })
        .catch(_ => {});
      console.log(row);
    },
    addBrand() {
      this.addBrandVisible = true;
      this.addBrandForm = {
        brandName: "",
        brandInfo: "",
        isEnabled: true,
        remark: ""
      };
      this.addBrandImgList = [];
    },
    confAddBrand(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let brandImg = this.addBrandImgList.map(item => {
            return item.url;
          });
          let params=this.addBrandForm;
          params.qualifyDocument=brandImg.join(",")

          wmsApi.$axiosAddNewSupply(params).then(res => {
            if (res.data.errno == 0) {
              this.$message.success("添加成功");
              this.addBrandVisible = false;
              this.querySearch();
            } else {
              this.$message.error(res.data.data);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editBrand(row) {
      this.brandInfo = row;
      this.editBrandVisible = true;
      let list = row.qualifyDocument == "" ? [] : row.qualifyDocument.split(",");
      this.editBrandImgList = list.map(item => {
        return { url: item };
      });
      this.editBrandForm =row;
    },
    confEditBrand(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let brandImg = this.editBrandImgList.map(item => {
            return item.url;
          });
           let params=this.editBrandForm;
          params.qualifyDocument=brandImg.join(",");
          params.id=this.brandInfo.id
          // let params = {
          //   createUserId: globalData.userInfo.id,
          //   brandName: this.editBrandForm.brandName,
          //   brandInfo: this.editBrandForm.brandInfo,
          //   isEnabled: this.editBrandForm.isEnabled,
          //   remark: this.editBrandForm.remark,
          //   logo: brandImg.join(","),
          //   id: this.brandInfo.id
          // };

          wmsApi.$axiosModifySupplier(params).then(res => {
            if (res.data.errno == 0) {
              this.$message.success("修改成功");
              this.editBrandVisible = false;
              this.querySearch();
            } else {
              this.$message.error(res.data.data);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    uploadOverrun: function() {
      this.$message({
        type: "error",
        message: "上传文件个数超出限制!最多上传5张图片!"
      });
    },
    uploadOverrun2: function() {
      this.$message({
        type: "error",
        message: "上传文件个数超出限制!最多上传5张图片!"
      });
    },
    handleRemove: function(file, fileList) {
      console.log(file, fileList);
      this.addBrandImgList = fileList;
    },
    handleRemove2: function(file, fileList) {
      console.log(file, fileList);
      this.editBrandImgList = fileList;
    },
    handleOnChange(file, fileList) {
      console.log(file);
      console.log(fileList);
      if (file.raw) {
        console.log("上传文件大小" + file.raw.size);
        let param = new FormData();
        param.append("createAccount", globalData.userInfo.userAccount);
        param.append("file", file.raw);
        Service.$ajaxAddFile(param).then(res => {
          console.log(res);
          if (res.data.errno == 0) {
            console.log(res);
            file.url = res.data.data.fileUrl;
            this.addBrandImgList = fileList;
            console.log(this.addBrandImgList);
          }
        });
      }
    },
    handleOnChange2(file, fileList) {
      console.log(file);
      console.log(fileList);
      if (file.raw) {
        console.log("上传文件大小" + file.raw.size);
        let param = new FormData();
        param.append("createAccount", globalData.userInfo.userAccount);
        param.append("file", file.raw);
        Service.$ajaxAddFile(param).then(res => {
          console.log(res);
          if (res.data.errno == 0) {
            console.log(res);
            file.url = res.data.data.fileUrl;
            this.editBrandImgList = fileList;
            console.log(this.addBrandImgList);
          }
        });
      }
    }
  }
};
</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}
>>> .el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}
</style>